// Paso 1 del asistente (PE-A3a y PE-A3a2): cantón del INEC, capas normativas y zona sísmica de la NEC.

import type { ZonaSismica } from './pe-amenazas';
import { CantonInec, esQuitoInec } from './pe-cantones';
import type { FuenteZona } from './pe-datos';
import { etiquetaPoblacion, PoblacionNEC, zonaPorCanton, ZonaDeCanton } from './pe-zonas-sismicas';

export { buscarCantones, cantonPorCodigo, cantonPorNombre } from './pe-cantones';

// Capa nacional siempre; si el cantón es el Distrito Metropolitano de Quito (INEC 1701), además las RTQ.
export function capasNormativas(codigoCanton: string | null): string {
  if (!codigoCanton) return 'Elige el cantón para saber qué normas aplican.';
  return esQuitoInec(codigoCanton)
    ? 'Se aplica la norma nacional (AM 1257) y, además, las RTQ 2026 del Cuerpo de Bomberos de Quito.'
    : 'Se aplica la norma nacional (AM 1257).';
}

export const ZONAS_SISMICAS: ZonaSismica[] = ['I', 'II', 'III', 'IV', 'V', 'VI'];

export interface ZonaPropuesta {
  zona: ZonaSismica | null;
  fuente: FuenteZona;
  lugar: string | null;   // emergency_plans.seismic_place
  nec: ZonaDeCanton | null;
}

// Decisión de JC (27/10/2026): al elegir el cantón se propone la población MÁS EXIGENTE de la Tabla 19; el
// responsable puede elegir otra población del cantón (el gestor también: es elegir dentro de la NEC). El
// ajuste manual de la zona sigue siendo solo del administrador. Si el cantón no aparece, zona a mano.
export function zonaAlElegirCanton(canton: CantonInec | undefined): ZonaPropuesta {
  const nec = canton ? zonaPorCanton(canton.codigo) : null;
  return nec
    ? { zona: nec.zona, fuente: 'nec_tabla19', lugar: etiquetaPoblacion(nec.poblacion), nec }
    : { zona: null, fuente: 'manual', lugar: null, nec: null };
}

export function zonaAlElegirPoblacion(p: PoblacionNEC): ZonaPropuesta {
  return { zona: p.zona, fuente: 'nec_tabla19', lugar: etiquetaPoblacion(p), nec: zonaPorCanton(p.codigoInec) };
}

export const AVISO_MAS_EXIGENTE = 'Zona más exigente del cantón; elige la población donde está el local para mayor precisión.';

const zComa = (z: number) => String(z).replace('.', ',');

export function notaZona(nec: ZonaDeCanton | null, fuente: FuenteZona | null, zona: ZonaSismica | null, elegida?: PoblacionNEC): string {
  if (nec && fuente === 'nec_tabla19' && elegida) {
    return `NEC-SE-DS, Tabla 19: población ${etiquetaPoblacion(elegida)}, Z = ${zComa(elegida.z)} (pág. ${elegida.pagina}).`;
  }
  if (nec && fuente === 'manual') {
    return `Cambiada a mano. En la Tabla 19 de la NEC, la población más exigente del cantón es zona ${nec.zona} (Z = ${zComa(nec.z)}).`;
  }
  if (zona) return 'Elegida a mano: el cantón no aparece en la Tabla 19 de la NEC-SE-DS.';
  return 'El cantón no aparece en la Tabla 19 de la NEC-SE-DS: elige la zona a mano.';
}
